import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Link,
} from "@mui/material";
import Logo from "../../images/resources/dddd.png";
import axios from "axios";
import { forgetpassword} from "../../Model/Login";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
  
    try {
      const arrayData = {
        email: email,
      };
  
      const results = await forgetpassword(arrayData);
  
      if (results.success === true || results.sucess === true) {
        // Assuming your API might return either `success` or `sucess`
        setLoading(false);
        // Optionally show a success message or redirect
        alert("Password reset link has been sent to your email.");
      } else {
        setLoading(false);
        setError(results.error || "Failed to send reset link. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      setError("An unexpected error occurred. Please try again.");
      console.error("Forgot password error:", err);
    }
  };



  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 10,
          p: 4,
          borderRadius: 3,
          boxShadow: 4,
          bgcolor: "background.paper",
          textAlign: "center",
        }}
      >
        <img
          src={Logo}
          alt="Leon Gallery Logo"
          style={{ maxWidth: 150, marginBottom: 24 }}
        />

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Forgot Password
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Enter your email to receive a reset link.
        </Typography>

        {submitted ? (
          <Alert severity="success" sx={{ mt: 2 }}>
            A password reset link has been sent to your email.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email Address"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              type="email"
              required
            />

            {error && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {error}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2, height: 45 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Send Reset Link"
              )}
            </Button>
          </form>
        )}

        <Link
          href="/login"
          underline="hover"
          sx={{ display: "block", mt: 3, fontSize: 14 }}
        >
          Back to Login
        </Link>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
